<template>
  <div class="bg-white rounded-xl shadow-sm w-full h-full flex flex-col">
    <!-- Header with gradient background -->
    <div class="bg-gradient-to-r from-ccm-blue-100 to-ccm-blue-200 px-4 py-2 rounded-t-xl">
      <div class="flex items-center justify-between">
        <h3 class="text-sm font-semibold text-white">
          {{ $props.label }}
        </h3>

        <div class="w-6 h-6 bg-white/20 rounded-full flex items-center justify-center">
          <div
            class="h-3 w-3 rounded-full"
            :class="[colour]"
          />
        </div>
      </div>
    </div>

    <!-- Content -->
    <div class="p-4 flex-1 flex flex-col justify-center items-center text-center">
      <div class="text-2xl font-bold text-gray-900 mb-1">
        {{ $props.value }}
      </div>

      <div
        v-if="$props.subtitle"
        class="text-xs text-gray-500"
      >
        {{ $props.subtitle }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    label: string;
    subtitle?: string;
    value?: string;
    threshold: 'low' | 'medium' | 'high';
  }>(),
  {
    value: undefined,
    subtitle: undefined,
  },
);

const colour = computed(() => {
  switch (props.threshold) {
    case 'low':
      return 'bg-red-500';

    case 'medium':
      return 'bg-orange-500';

    default:
      return 'bg-green-500';
  }
});
</script>

<style scoped></style>
